// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/rpc/v2/error_reason.proto" (package "sui.rpc.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
/**
 * @generated from protobuf enum sui.rpc.v2.ErrorReason
 */
export enum ErrorReason {
	/**
	 * @generated from protobuf enum value: ERROR_REASON_UNKNOWN = 0;
	 */
	ERROR_REASON_UNKNOWN = 0,
	/**
	 * @generated from protobuf enum value: FIELD_INVALID = 1;
	 */
	FIELD_INVALID = 1,
	/**
	 * @generated from protobuf enum value: FIELD_MISSING = 2;
	 */
	FIELD_MISSING = 2,
}
